<script setup>
import {defineEmits, defineProps} from "vue";
import MapSelector from "@/components/MapPage/MapNavbar/MapSelector.vue";
import MapFilter from "@/components/MapPage/MapNavbar/MapFilter.vue";

const emit = defineEmits(["update-filter", "close-news-list",
  "set-active-map", "show-create-map-modal", "get-project-map-files"]);

defineProps({
  activeMap: {
    type: [Object, null],
    required: true,
  },
  mapList: {
    type: Array,
    required: true
  }
});
</script>

<template>
  <div class="map-navbar">
    <MapSelector
      :map-list="mapList"
      :active-map="activeMap"
      @get-project-map-files="emit('get-project-map-files')"
      @show-create-map-modal="emit('show-create-map-modal')"
      @set-active-map="(newMap) => emit('set-active-map', newMap)"
    />
    <MapFilter
      @update-filter="emit('update-filter')"
    />
  </div>
</template>

<style scoped lang="scss">
.map-navbar {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 0 15px;
}

.map-filter {
  display: flex;
  gap: 10px;
}


</style>